import Vue from 'vue'
import Vuex from 'vuex'
import { slug } from 'vue-string-filter'
import VueScrollTo from 'vue-scrollto'
import VueMeta from 'vue-meta'
import App from './App.vue'
import state from './store/state'
import getters from './store/getters'
import actions from './store/actions'
import mutations from './store/mutations'

import './styles/home.css'
import './styles/app.scss'
import router from './router'

Vue.use(Vuex)
Vue.use(VueMeta)

Vue.filter('slug', slug)
Vue.use(VueScrollTo)

Vue.filter('multiFilter', (arr, filters, find) => {
  let tempFilters = []
  filters.forEach((obj) => {
    tempFilters.push(obj)
  })
  console.log(tempFilters)
  return arr.filter(x => tempFilters.includes(x[`${find}`]))
});

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store: new Vuex.Store({
    state,
    getters,
    actions,
    mutations
  })
}).$mount('#ras-app')
